import { downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { MailUnitService } from '@contact/upgrade';

import Eptica from './eptica/eptica.module.ajs';
import Giveup from './giveup/popup-giveup.module.ajs';
import Memo from './memo/memo.module.ajs';
import { default as outgoingMailServiceName, OutgoingMailDeprecatedService } from './outgoing-mail-deprecated.service';
import Review from './review/popup-review.module.ajs';

export default module('contact.agent.core.channel-digit.mail', [Eptica, Giveup, Memo, Review])
  .run([outgoingMailServiceName, () => {}])
  .service(outgoingMailServiceName, OutgoingMailDeprecatedService)
  .factory('mailUnitService', downgradeInjectable(MailUnitService as any)).name;
